import { Navigate, Outlet, useParams } from 'react-router-dom'
import { bindParams, checkLogin } from '../utilities/helpers'
import { HOME } from 'configs/path'
import { getAppSetting } from 'services/appService'
import { useAppDispatch } from 'hooks'
import { useEffect, useState } from 'react'
import { setAppSetting } from '../redux/slices/appSlice'
import Page404 from './page404/page404'
import { Spin } from 'antd'

const LoginedRoute = () => {
  const { app } = useParams()
  const dispatch = useAppDispatch()
  const [isMatchUrl, setIsMatchUrl] = useState(true)
  const [isLoading, setIsLoading] = useState(true)

  const handleGetAppSetting = async () => {
    const appSetting = await getAppSetting({ app_id: app as string })
    if (appSetting.success) {
      dispatch(setAppSetting(appSetting.data))
    } else {
      setIsMatchUrl(false)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    const timeOut = setTimeout(() => {
      handleGetAppSetting()
    }, 100)
    return () => {
      clearTimeout(timeOut)
    }
  }, [app])
  if (!isMatchUrl) {
    return <Page404 />
  }

  if (isLoading) {
    return (
      <div className="full-screen__overlay">
        <Spin />
      </div>
    )
  }

  return checkLogin() ? (
    <Navigate
      to={bindParams(HOME, {
        app: app
      })}
    />
  ) : (
    <Outlet />
  )
}

export default LoginedRoute
